import { Capacitor } from "@capacitor/core";

export default Capacitor.isNativePlatform();
